import React, { useState } from 'react';
import { connect } from 'react-redux';
//Actions
import { getUserFullName, getUserPhoneNumber } from '../../actions/utils';
import { saveClanData } from '../../actions/clans';
//Components
import Actions from 'locki-dashboard-navigation/dist/actions';
import GeneralData from './GeneralData';
import LoadingModal from 'locki-dashboard-navigation/dist/loadingModal';
import PhoneNumbers from './PhoneNumbers';
import Tags from './Tags';
//Material-ui
import Typography from '@material-ui/core/Typography';
//react-phone-number-input
import { isValidPhoneNumber } from 'react-phone-number-input';

function Clan({
  clan,
  close,
  getUserFullName,
  getUserPhoneNumber,
  saveClanData,
}) {
  const id = clan.id || null;
  const [address, setAddress] = useState(clan.address || '');
  const [loadingModal, setLoadingModal] = useState(false);
  const [members, setMembers] = useState(clan.members || []);
  const [name, setName] = useState(clan.name || '');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [tag, setTag] = useState('');
  const [tags, setTags] = useState(clan.tags || []);
  function handleLoadingModal() {
    setLoadingModal(!loadingModal);
  }
  function handlePhone(phone) {
    if (!isNaN(phone)) {
      if (isValidPhoneNumber(phone)) {
        //slice(0) prevents changes on original array
        const membersUpdate = members.slice(0);
        membersUpdate.push(phone);
        setMembers(membersUpdate);
        setPhoneNumber('');
      } else {
        setPhoneNumber(phone);
      }
    }
  }
  function handleTag() {
    //slice(0) prevents changes on original array
    const tagsUpdate = tags.slice(0);
    tagsUpdate.push(tag);
    setTags(tagsUpdate);
    setTag('');
  }
  function handleRemove(i, name) {
    if (name === 'members') {
      //slice(0) prevents changes on original array
      const membersUpdate = members.slice(0);
      membersUpdate.splice(i, 1);
      setMembers(membersUpdate);
    } else {
      //slice(0) prevents changes on original array
      let tagsUpdate = tags.slice(0);
      tagsUpdate.splice(i, 1);
      setTags(tagsUpdate);
    }
  }
  function handleSave() {
    const tagsToSave = {};
    tags.forEach((element) => {
      tagsToSave[element] = true;
    });
    return saveClanData({
      address,
      id,
      members,
      name,
      tags: tagsToSave,
    });
  }
  return (
    <div>
      <LoadingModal
        callback={close}
        closeModal={handleLoadingModal}
        open={loadingModal}
        promise={handleSave}
        successLabel="Familia guardada"
      />
      <Typography variant="h6">
        {id ? 'Editar Familia' : 'Nueva Familia'}
      </Typography>
      <br />
      <GeneralData
        address={address}
        name={name}
        setAddress={setAddress}
        setName={setName}
      />
      <br />
      <PhoneNumbers
        getUserFullName={getUserFullName}
        getUserPhoneNumber={getUserPhoneNumber}
        handlePhone={handlePhone}
        handleRemove={handleRemove}
        members={members}
        phone={phoneNumber}
      />
      <br />
      <Tags
        handleRemove={handleRemove}
        handleTag={handleTag}
        setTag={setTag}
        tag={tag}
        tags={tags}
      />
      <br />
      <Actions
        color="secondary"
        primaryAction={handleLoadingModal}
        primaryLabel="GUARDAR"
        secondaryAction={close}
        secondaryLabel="CANCELAR"
      />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  getUserFullName: (userUid) => dispatch(getUserFullName(userUid)),
  getUserPhoneNumber: (userUid) => dispatch(getUserPhoneNumber(userUid)),
  saveClanData: (clan) => dispatch(saveClanData(clan)),
});

export default connect(undefined, mapDispatchToProps)(Clan);
